module.exports = __webpack_public_path__ + "img/ArticlesofAssociationorAnnualReturnZh.de9e81a2.jpg";